import React, { useCallback, useEffect } from "react";
import { AlertTriangle, X } from "lucide-react";

export function ClosePopup({ message, title, onCancel, closePopup }) {
    const handleClose = useCallback(() => {
        onCancel && onCancel();
        closePopup();
    }, [onCancel, closePopup]);

    useEffect(() => {
        document.body.style.overflow = "hidden";

        const onKeyDown = (event) => {
            if (event.key === "Escape") {
                handleClose();
            }
        };

        document.addEventListener("keydown", onKeyDown);

        return () => {
            document.body.style.overflow = "";
            document.removeEventListener("keydown", onKeyDown);
        };
    }, [handleClose]);

    return (
        <div className="oct-shared-popup" role="dialog" aria-modal="true" aria-labelledby="oct-shared-close-popup-title">
            <div className="oct-shared-popup__backdrop" onClick={handleClose} />

            <div className="oct-shared-popup__dialog oct-shared-popup__dialog--compact" onClick={(event) => event.stopPropagation()}>
                <div className="oct-shared-popup__header">
                    <div className="oct-shared-popup__title-wrap">
                        <div className="oct-shared-popup__title-icon">
                            <AlertTriangle size={18} />
                        </div>
                        <h4 id="oct-shared-close-popup-title" className="oct-shared-popup__title">
                            {title}
                        </h4>
                    </div>

                    <button
                        type="button"
                        className="oct-shared-popup__close"
                        onClick={handleClose}
                        aria-label="Close popup"
                    >
                        <X size={18} />
                    </button>
                </div>

                <div className="oct-shared-popup__body oct-shared-popup__body--warning">
                    <p className="oct-shared-popup__message oct-shared-popup__message--warning">{message}</p>
                </div>

                <div className="oct-shared-popup__footer oct-shared-popup__footer--end">
                    <button
                        type="button"
                        className="btn oct-shared-popup__btn oct-shared-popup__btn--secondary"
                        onClick={handleClose}
                    >
                        Close
                    </button>
                </div>
            </div>
        </div>
    );
}
